import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { BulkSOWEditor } from './BulkScopeOfWorkEditor';
import { LOAOutreachTesting } from './LOAOutreachTesting';
import { MedicalRecordsAutomation } from './MedicalRecordsAutomation';
import { NotificationTesting } from './NotificationTesting';
import { RainmakerPreview } from './RainmakerPreview';
import { RetainerAnalytics } from './RetainerAnalytics';
import { ZaddyEmailMatching } from './ZaddyEmailMatching';

const TAB_NAMES = [
  'notification-testing',
  'email-matching',
  'rainmaker-preview',
  'medrec-automation',
  'loa-outreach',
  'retainer-analytics',
  'bulk-sow',
] as const;

export const ZaddyPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialTab = tabParam
    ? TAB_NAMES.indexOf(tabParam as (typeof TAB_NAMES)[number])
    : 0;
  const [activeTab, setActiveTab] = useState(initialTab >= 0 ? initialTab : 0);

  useEffect(() => {
    if (tabParam) {
      const tabIndex = TAB_NAMES.indexOf(
        tabParam as (typeof TAB_NAMES)[number],
      );
      if (tabIndex >= 0 && tabIndex !== activeTab) {
        setActiveTab(tabIndex);
      }
    }
  }, [tabParam]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setSearchParams({ tab: TAB_NAMES[newValue] });
  };

  return (
    <Box
      sx={{
        height: 'calc(100vh - 64px)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Notification Testing" />
          <Tab label="Email Matching" />
          <Tab label="Rainmaker Preview" />
          <Tab label="MedRec Automation" />
          <Tab label="LOA Outreach" />
          <Tab label="Retainer Analytics" />
          <Tab label="Bulk SOW" />
        </Tabs>
      </Box>

      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        {activeTab === 0 && <NotificationTesting />}
        {activeTab === 1 && <ZaddyEmailMatching />}
        {activeTab === 2 && <RainmakerPreview />}
        {activeTab === 3 && <MedicalRecordsAutomation />}
        {activeTab === 4 && <LOAOutreachTesting />}
        {activeTab === 5 && <RetainerAnalytics />}
        {activeTab === 6 && <BulkSOWEditor />}
      </Box>
    </Box>
  );
};
